import { useFormContext } from 'react-hook-form'
import { Option } from '~/shared/config/constants'
import { Button } from '~/shared/ui/Buttons'
import { Title, ButtonsWrapper } from './styled'

type MultiButtonsProps = {
  field: string
  title: string
  options: Option[]
}

export function MultiButtons({ field, title, options }: MultiButtonsProps) {
  const { setValue, watch } = useFormContext()

  const valuesForm: Option[] = watch(field) || []

  const handleSelectedValueCheck = (id: UniqueId) => {
    return valuesForm.some((selectedValue) => selectedValue?.id === id)
  }

  const handleChange = (option: Option) => {
    if (handleSelectedValueCheck(option.id)) {
      setValue(
        field,
        valuesForm.filter((valueForm) => valueForm?.id !== option.id),
      )
    } else {
      setValue(field, [...valuesForm, option])
    }
  }

  return (
    <div>
      <Title>{title}</Title>

      <ButtonsWrapper>
        {options.map((option) => (
          <Button
            variant={
              handleSelectedValueCheck(option.id)
                ? 'blueFlooded'
                : 'whiteFlooded'
            }
            style={{
              borderRadius: '12px',
              '--border-radius': '12px',
            }}
            contentProps={{
              style: { padding: '14px 12px' },
            }}
            onClick={() => handleChange(option)}
            key={option.id}
          >
            {option.label}
          </Button>
        ))}
      </ButtonsWrapper>
    </div>
  )
}
